export const PASSTHRU_TIMEOUT_ERROR_MESSAGE = 'Unusually long passthru time';

export const getSentryEventErrorMessage = (event: {
	exception?: { values?: Array<{ value?: string }> };
	message?: string;
}) => event.exception?.values?.[0]?.value ?? event.message ?? '';

const REPLAY_SKIP_MESSAGE_FRAGMENTS = [
	PASSTHRU_TIMEOUT_ERROR_MESSAGE
] as const

export const shouldSkipReplayForError = (
	event: Parameters<typeof getSentryEventErrorMessage>[0]
): boolean => {
	const message = getSentryEventErrorMessage(event)
	return REPLAY_SKIP_MESSAGE_FRAGMENTS.some((fragment) =>
		message.includes(fragment)
	)
}
